import { render, staticRenderFns } from "./Promotor.vue?vue&type=template&id=2c4d790e&"
import script from "./Promotor.vue?vue&type=script&lang=js&"
export * from "./Promotor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QTabs,QTab,QBtnDropdown,QList,QItem,QItemSection,QTabPanels,QTabPanel} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QTabs,QTab,QBtnDropdown,QList,QItem,QItemSection,QTabPanels,QTabPanel})
